import React, { useEffect, useState } from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Flex,
  VStack,
  Input,
  HStack,

} from '@chakra-ui/react';

import { FaArrowLeft, FaArrowRight, FaEye, FaTrash,  } from 'react-icons/fa';
import axios from 'axios';
import { backendurl } from '../path';
import { useNavigate } from 'react-router-dom';

const AllStudent = () => {
  const navigate = useNavigate();

    const [students,setstudents] = useState([]);
  // Dummy data for students

  
useEffect(() => {
const getdata = async()=>{
    const response = await axios.post(`${backendurl}/get-students`,{});
    console.log(response.data);
    setstudents(response.data);

}

getdata();

}, [])



  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");



  // Pagination
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = students.slice(indexOfFirstRow, indexOfLastRow);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const filteredstudent = searchTerm
  ? currentRows.filter((studentone) =>
      studentone.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
  : currentRows;

  const handlevisit = (data)=>{
    navigate(`/student/${data}`);
    }
    const handledelete = async(data)=>{
      const response = await axios.post(`${backendurl}/delete-student`,{"_id":data});
    if(response.data.Deleted)
    {
    window.location.reload();
    }
      }
    


  return (
    <VStack w={'100%'} mt={['20vh','25vh']} alignItems={'center'}  overflowX={'hidden'}>

<Input  w={'40%'} placeholder='search name' value={searchTerm} onChange={(e)=>setSearchTerm(e.target.value)} />
        
     

       
      <Table variant="striped" colorScheme="teal" w={'70%'} size={'sm'}>
       
        <Thead>
          <Tr>
            <Th>Student Name</Th>
            <Th>Class</Th>
            <Th>Mother Name</Th>
            <Th>Father Name</Th>
            <Th>Phone No</Th>
            <Th>Address</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {filteredstudent.map((stu) => (
            <Tr key={stu._id}>
              <Td>{stu.name}</Td>
              <Td>{stu.classname}</Td>
              <Td>{stu.mothername}</Td>
              <Td>{stu.fathername}</Td>
              <Td>{stu.phone}</Td>
              <Td>{stu.address}</Td>
              <Td ><HStack w={'full'} spacing={4}>
              <FaEye size={20} onClick={()=>handlevisit(stu._id)} />
                <FaTrash size={20} onClick={()=>handledelete(stu._id)} />
              </HStack></Td>
              
            </Tr>
          ))}
        </Tbody>
      </Table>
      <Flex justifyContent="space-between" mt={2} gap={4}>
        <Button onClick={() => paginate(currentPage - 1)} colorScheme={currentPage===1?'white':'orange'} disabled={currentPage === 1}><FaArrowLeft/></Button>
        <Button onClick={() => paginate(currentPage + 1)} disabled={indexOfLastRow >= filteredstudent.length}><FaArrowRight/></Button>
      </Flex>
  </VStack>
  );
};

export default AllStudent;
